import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Shield, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminLogin() {
  const { login, isAdmin, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  if (isAuthenticated && isAdmin) { navigate('/admin'); return null; }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await login(email, password, true);
      toast.success('Yönetici erişimi verildi');
      navigate('/admin');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Yönetici girişi başarısız');
    } finally { setIsLoading(false); }
  };

  return (
    <div className="min-h-dvh bg-background flex flex-col">
      <div className="relative py-12 px-6 flex flex-col items-center justify-center bg-card border-b border-border/70">
        <div className="w-14 h-14 rounded-2xl bg-[hsl(28,92%,56%)] flex items-center justify-center mb-3">
          <Shield className="w-7 h-7 text-white" />
        </div>
        <h1 className="text-2xl font-semibold tracking-tight font-display">Yönetici Portalı</h1>
        <p className="text-muted-foreground text-sm mt-1">Yalnızca yetkili erişim</p>
      </div>
      <div className="flex-1 flex items-start justify-center px-4 py-8">
        <div className="w-full max-w-md">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="bg-card rounded-xl border border-border/70 p-6 space-y-4 shadow-sm">
              <div className="space-y-2">
                <label className="text-sm font-medium text-foreground">Yönetici E-postası</label>
                <Input data-testid="admin-login-email" type="email" placeholder="admin@admin.com" value={email}
                  onChange={e => setEmail(e.target.value)} required className="rounded-xl" />
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium text-foreground">Şifre</label>
                <Input data-testid="admin-login-password" type="password" placeholder="Yönetici şifresini girin" value={password}
                  onChange={e => setPassword(e.target.value)} required className="rounded-xl" />
              </div>
            </div>
            <Button data-testid="admin-login-submit" type="submit"
              className="w-full rounded-xl h-12 text-base font-medium bg-[hsl(28,92%,56%)] hover:bg-[hsl(28,92%,48%)] text-white" disabled={isLoading}>
              {isLoading ? 'Doğrulanıyor...' : 'Yönetim Paneline Eriş'}
            </Button>
          </form>
          <div className="mt-6 text-center">
            <button onClick={() => navigate('/')} className="text-sm text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1">
              <ArrowLeft className="w-4 h-4" /> Kullanıcı Girişine Dön
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
